<template>
  <div id="company-page" v-if="company">
    <div class="cover" v-if="companyImage">
      <img :src="companyImage">
    </div>
    <div id="content">
      <div class="side-box">
        <div class="title">
          <h1>{{company.company_data.title}}</h1>
          <p>{{company.company_data.address}}</p>
        </div>
        <company-info :data="company.company_data"></company-info>
        <div v-if="company.images_list.length > 0">
        <h2 class="gallery-title">Galéria</h2>
        <company-gallery :images="company.images_list"></company-gallery>
          </div>
      </div>
      <div class="main">
        <div class="description" v-html="companyDescription"></div>
        <div class="programs" v-if="programs && programs.length > 0">
          <h2>Programok</h2>
          <div v-for="(data, day) in programTime">
            <h3>{{day}}</h3>
            <div v-for="(programs) in data" class="program">
              <p v-for="item in programs">

              <span>{{item.time}} <span v-if="item.endTime"> - {{item.endTime}}</span>:</span>
              {{item.title}}
              <br>
              {{item.description}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import companyGallery from '../components/companyGallery'
  import companyInfo from '../components/companyInfo'
  import {sortProgramsByDate, reducePrograms} from '../utils'

  export default {
    name: 'company',
    components: {companyGallery, companyInfo},
    computed: {
      company () {
        return this.$store.state.companies.currentCompany
      },
      companyImage () {
        return `${this.$store.state.config.baseURL}${this.company.company_data.image}`
      },
      companyDescription () {
        return this.company.company_data.description
      },
      programs () {
        return this.company.programs[this.year]
      },
      programTime () {
        return this.programs
          .sort(sortProgramsByDate)
          .reduce(reducePrograms, {})
      },
      year() {
        return this.$route.params.year
      }
    },
    mounted () {
      const id = this.$route.params.id
      
      this.$store.dispatch('companies/getCompanyById', id)
      this.$store.dispatch('theme/getTheme', this.year);
    }
  }
</script>

<style scoped>
  #company-page {
    padding-top: 50px;
  }

  #content {
    width: 100%;
    max-width: 1240px;
    padding: 60px 40px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
  }

  h1 {
    position: relative;
    font-size: 28px;
    text-align: left;
    color: var(--colorB);
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 45px;
  }

  h2 {
    position: relative;
    font-size: 28px;
    font-weight: 600;
    color: var(--colorA);
    margin-bottom: 45px;
  }

  h3 {
    font-weight: 600;
  }

  h1::after,
  h2::after {
    position: absolute;
    content: '';
    width: 30px;
    height: 3px;
    left: 0;
    bottom: -15px;
  }

  .gallery-title {
    color: var(--colorB);
    text-align: left;
  }

  h1::after,
  .gallery-title::after {
      background-color: var(--colorA);
  }

  h2::after {
      background-color: var(--colorB);
  }

  p {
    font-size: 16px;
  }

  .cover {
    width: 100%;
    height: 420px;
    filter: saturate(0);
  }

  .cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .title {
    text-align: left;
    margin-bottom: 80px;
  }

  .main {
    width: 70%;
    margin: 0 0 0 auto;
    padding: 40px 80px 40px 20px;
    text-align: left;
  }

  .side-box {
    width: 25%;
  }

  .program span {
    color: var(--colorB);
    font-weight: 600;
  }

  .description >>> img {
    width: 100%;
  }

  .description >>> p {
    font-size: 16px;
  }

  .description >>> a {
    color: var(--colorB);
  }

  @media (max-width: 600px) {

    .cover {
      height: 240px;
    }

    #content {
      flex-direction: column;
      padding: 40px 0;
    }

    .title {
      margin-bottom: 40px;
      padding-left: 30px;
    }

    .title h1 {
      font-size: 22px;
    }

    .side-box {
      width: 100%;
    }

    .gallery-title {
      position: relative;
      margin-left: 30px;
    }

    .gallery {
      padding: 0 30px;
    }

    .main {
      width: 100%;
      padding: 40px 30px;
    }
  }
</style>
